import View from '../View';

export default View.extend({
  featureHeight : 5,
  labels        : true,
  repeatLabels  : true,
  bump          : true,
});
